import { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Mail } from "lucide-react";

export default function AdminEmailLog() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/api/admin/emails");
        setItems(data);
      } catch (e) {
        toast.error(formatApiError(e.response?.data?.detail) || e.message);
      } finally {
        setLoading(false);
      }
    })();
  }, []);
  return (
    <div data-testid="admin-emails">
      <p className="text-forest text-xs tracking-[0.18em] uppercase font-semibold mb-2">Operations</p>
      <h1 className="font-heading text-3xl md:text-4xl font-semibold text-forest">Email log</h1>
      <p className="text-neutral-500 text-[13.5px] mt-1">Notifications queued for applicants and admin. Real email delivery can be enabled later.</p>

      <div className="mt-6 rounded-2xl bg-white border border-black/5 overflow-hidden">
        {loading ? (
          <div className="p-8 text-neutral-500">Loading…</div>
        ) : items.length === 0 ? (
          <div className="p-10 text-center text-neutral-500">No notifications yet.</div>
        ) : (
          <ul className="divide-y divide-black/5">
            {items.map((e, i) => (
              <li key={i} className="p-5 grid md:grid-cols-[24px_1fr] gap-3" data-testid={`email-item-${i}`}>
                <Mail size={18} className="text-forest mt-1"/>
                <div>
                  <div className="flex flex-wrap items-center gap-2">
                    <span className="text-[11px] rounded-full px-2 py-0.5 bg-mist text-forest font-semibold uppercase tracking-widest">{e.kind}</span>
                    <span className="text-[13.5px] font-semibold text-forest">{e.subject}</span>
                  </div>
                  <p className="text-[12.5px] text-neutral-500 mt-1">To: {e.to || "—"} · {(e.created_at || "").slice(0,16).replace("T", " ")}</p>
                  <pre className="mt-2 text-[13px] text-neutral-700 whitespace-pre-wrap font-sans">{e.body}</pre>
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
